const contentful = require('contentful');

const client = contentful.createClient({
    space: "h6mg9r7ateot",
    accessToken: "SroQ9yI_-8t5JCzFh7MLCI5gpojbSklz-gMXlW6CA08" 
});

export default client; 